// Include scss
import "../scss/index.scss";

// Images
import "./images.js";

/* 
    Libs 
*/

// Lazyload
import LazyLoad from "vanilla-lazyload";
var myLazyLoad = new LazyLoad();
myLazyLoad.update();

// Swiper
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);
import '../../node_modules/swiper/swiper.scss';

let arSliders = [];
function initSliders() {
    for(let slider of document.querySelectorAll('.js-ucti-slider')) {
        let paginationElem = slider.querySelector('.swiper-pagination');
        //console.log(slider, paginationElem);
        let swiper = new Swiper(slider, {
            slidesPerView: 1,
            enteredSlides: true,
            pagination: {
                el: paginationElem,
            },
            breakpoints: {
                76800: {
                    enabled: false
                },
            },
            on: {
                'afterInit': function(){
                    setSildeProgress(this);
                },
                'slideChange': function() {
                    setSildeProgress(this);
                    stopAllVideo();
                }
            }
        });

        arSliders.push(swiper);
    }
}

function destroySliders() {
    for(let swiper of arSliders) {
        swiper.destroy(true, true);
    }
    arSliders = [];
}

function setSildeProgress(swiper) {
    let slider = swiper.el;
    let num = slider.querySelector('.swiper-num');
    if(!num) {
        return;
    }
    num.innerText = (swiper.activeIndex+1) + "/" + swiper.slides.length;
}

let isSliderItit = false;
function checkWidth() {
    if(window.innerWidth < 768) {
        if(!isSliderItit) {
            initSliders();
            isSliderItit = true;
        }
    } else {
        if(isSliderItit) {
            destroySliders();
            isSliderItit = false;
        }
    }
}

checkWidth();
window.addEventListener('resize', function(){
    checkWidth();
});


document.addEventListener('DOMContentLoaded', function() {
    
    let videosBlocks = document.querySelectorAll('.js-video-block');
    for(let videosBlock of videosBlocks) {
        console.log(videosBlock)
        let poster = videosBlock.querySelector('.js-video-start');
        let video = videosBlock.querySelector('.js-video');

        poster.addEventListener('click', function() {      
            // Play current video or stop is played
            if(!videosBlock.classList.contains('active')) {
                stopAllVideo();
                videosBlock.classList.add('active');
                video.play();
            } else {
                stopAllVideo();
            }
        });

        video.addEventListener('ended', function() {
            stopAllVideo();
        });
    }
});

function stopAllVideo() {
    let videosBlocks = document.querySelectorAll('.js-video-block');
    for(let videosBlock of videosBlocks) {
        let video = videosBlock.querySelector('.js-video');
        video.pause();
        video.currentTime = 0;
        videosBlock.classList.remove('active');
    }
}


// MagicScroll + GSAP
import ScrollMagic from 'scrollmagic';
import { TweenMax, TimelineMax } from "gsap"; // What to import from gsap
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
 

/*
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax); // Pass gsap import to Scrollmagic

var controller = new ScrollMagic.Controller();
var scene = new ScrollMagic.Scene({triggerElement: "#my-sticky-element-trigger", duration: "50%"})
    .setTween("#my-sticky-element", {
        backgroundColor: "blue", 
        scale: 0.7,
        x: '300px',
        rotate: 180
    })
    .addTo(controller);

    */
